import styled, { css } from "styled-components";
import { propStyling, tombac } from "../../shared";
import { textStyles } from "../../shared/textStyles";
const Root = styled.ul.withConfig({
  displayName: "StyledListBox__Root"
})(["all:initial;background-color:", ";border-radius:", ";box-shadow:", " ", ";display:flex;flex-flow:column;padding:", ";overflow-y:auto;", ""], tombac.color.white, tombac.unit(5), tombac.unit(0, 1, 3, 0), tombac.alpha("neutral", 16), tombac.space(1, 0), propStyling);
const Item = styled.li.withConfig({
  displayName: "StyledListBox__Item"
})(["all:initial;cursor:pointer;flex:none;padding:", ";", " ", " ", " ", " ", " ", " ", " ", ""], tombac.space(0.5, 2), tombac.text(), _ref => {
  let {
    hasPrepend
  } = _ref;
  return hasPrepend && css(["display:flex;align-items:center;"]);
}, _ref2 => {
  let {
    isSelected
  } = _ref2;
  return isSelected && css(["background-color:", ";color:", ";"], tombac.color("accent", 100), tombac.color("accent", 500));
}, _ref3 => {
  let {
    isFocused,
    isSelected
  } = _ref3;
  return isFocused && css(["background-color:", ";"], isSelected ? tombac.color("accent", 200) : tombac.color("neutral", 300));
}, _ref4 => {
  let {
    isPressed,
    isSelected
  } = _ref4;
  return isPressed && css(["background-color:", ";"], isSelected ? tombac.color("accent", 100) : tombac.color("neutral", 400));
}, _ref5 => {
  let {
    isDisabled
  } = _ref5;
  return isDisabled && css(["color:", ";"], tombac.color("neutral", 500));
}, propStyling, textStyles);
export const StyledListBox = {
  Root,
  Item
};
//# sourceMappingURL=StyledListBox.js.map